"use strict";

var _require = require('../../../helpers'),
    computeRoundedQuantity = _require.computeRoundedQuantity;

module.exports = function (accumulator, printJob, product, component) {
  var is_new_spool = ['Botanical', 'Cashmere', 'French Blue', 'Lake', 'Latte', 'Laurel', 'Mink', 'Moss', 'Noir', 'Olive', 'Sapphire', 'Snow'].includes(component.acc_ribbon);
  var divisor;

  if (is_new_spool) {
    switch (component.component_type) {
      case 'BasicProgram':
      case 'DeluxeProgramCoverPage':
        divisor = component.product_size === '4x10' ? 5 : 7;
        break;

      case 'FlatProgram':
        divisor = 8;
        break;

      case 'SquareProgram':
        divisor = 5;
        break;

      case 'WeddingMenu':
      case 'LetterpressWeddingMenu':
        divisor = 9;
        break;

      case 'FavorTag':
        divisor = 22;
        break;

      case 'Invitation':
      case 'LetterpressInvitation':
      case 'SaveTheDate':
      case 'LetterpressSaveTheDate':
        divisor = component.orientation === 'L' ? 5 : 7;
        break;

      default:
        break;
    }
  } else {
    switch (component.component_type) {
      case 'BasicProgram':
      case 'DeluxeProgramCoverPage':
        divisor = component.product_size === '4x10' ? 4.5 : 6.5;
        break;

      case 'FlatProgram':
        divisor = 7.5;
        break;

      case 'SquareProgram':
        divisor = 4.5;
        break;

      case 'WeddingMenu':
      case 'LetterpressWeddingMenu':
        divisor = 8.5;
        break;

      case 'FavorTag':
        divisor = 13;
        break;

      case 'Invitation':
      case 'LetterpressInvitation':
      case 'SaveTheDate':
      case 'LetterpressSaveTheDate':
        divisor = component.orientation === 'L' ? 4.5 : 6.5;
        break;

      default:
        break;
    }
  }

  var roundedQuantity = computeRoundedQuantity(component);
  return Math.ceil(roundedQuantity / divisor);
};